// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Folder(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Folder" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 4L9 4L11 6H21L21 20H3L3 4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Folder.js.map